module.exports = __webpack_public_path__ + "static/media/home-bg.90af7dee.jpg";